/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import route_case from "../route/route-case";
import route_study from "../route/route-study";
import Home from "../components/AWSHome/";
import { Auth, Hub } from "aws-amplify";
import { useState, useEffect, useMemo } from "react";
import SignOut from "../auth/SignOut";
const HomeContainer = () => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
  }, []);

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
    } catch (err) {
      console.log("error: ", err);
    }
  }
  const navigation = useMemo(() => {
    const route = user?.email === 'democlinical@singularity.ai' ? route_case : route_study;
    return route
  }, [user])
  return (
    <Home
      userInfo={user}
      navigation={navigation}
      basename="/home"
      handleSignOut={SignOut}
    ></Home>
  );
};

export default HomeContainer;
